import axios from 'axios';

// 创建axios实例（如果项目中已有全局实例可直接使用）
const request = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || '/api', // 可配置基础URL
    timeout: 5000, // 请求超时时间
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    }
});

/**
 * 用户登录API
 * @param {Object} loginForm - 登录表单数据
 * @param {string} loginForm.username - 用户名
 * @param {string} loginForm.password - 密码
 * @returns {Promise} - 返回登录结果的Promise对象
 */
export function login(loginForm) {
    let url = '/users/user_login?t='+Date.now();
    return new Promise((resolve, reject) => {
        request.post(url, loginForm)
            .then(response => {
                // 成功响应处理
                if (response.data) {
                    resolve(response.data);
                } else {
                    reject(new Error('登录失败：未返回数据'));
                }
            })
            .catch(error => {
                // 错误处理
                const errorMsg = error.response?.data?.message ||
                    error.message ||
                    '登录请求失败，请重试';
                reject(new Error(errorMsg));
            });
    });
}